<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import type { Coordinates } from '$lib/components/map/types';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as m from '$paraglide/messages';
	import ButtonMarker from './ButtonMarker.svelte';

	interface Props {
		coordinates: Coordinates;
		icon: IconName;
	}

	const { coordinates, icon }: Props = $props();
</script>

<ButtonMarker
	lngLat={[coordinates.lng, coordinates.lat]}
	class="bg-transparent"
	ariaLabel={m.poi_marker__pin()}
>
	<span
		class="border-1.5 border-solid border-colored-neutral-strongest flex text-md leading-none rd-8 bg-origin p-0.5"
	>
		<Icon {icon} class="color-white" tag="span" />
	</span>
</ButtonMarker>
